import script from "./VideoCall.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCall.vue?vue&type=script&setup=true&lang=js"

import "./VideoCall.vue?vue&type=style&index=0&id=4b03f4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b03f4fa"]])

export default __exports__